import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import useWindowDimensions from "../../customhooks/useWindowDimensions";
import Wait from "../Wait";
import "./EstadoCuenta.css";
import EstadoCuentaFooter from "./EstadoCuentaFooter";
import useTable from "./useTable";

const TableEstadocuenta = ({ data, rowsPerPage }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [page, setPage] = useState(1);
  const [isfilter, setIsfilter] = useState(false);
  const [invoicesTemp, setInvoicesTemp] = useState([]);

  if (data.length > 0 && invoicesTemp.length === 0 && isfilter === false) {
    setInvoicesTemp(data);
  }
  const { slice, range } = useTable(invoicesTemp, page, rowsPerPage);

  const filter = (column, e) => {
    const keyword = e.target.value;
    if (keyword !== "") {
      setIsfilter(true);
      const results = data.filter((dataT) => {
        switch (column) {
          case 0:
            return dataT.invoiceField.includes(keyword.toLowerCase());
          case 1:
            return dataT.transDateField.includes(keyword.toLowerCase());
          case 2:
            return String(dataT.amountMSTField).includes(keyword.toLowerCase());
          case 3:
            return String(dataT.lIVPInvoiceRemainAmountField).includes(
              keyword.toLowerCase()
            );
          case 4:
            return dataT.lIVPInvoicePaymDateField.includes(
              keyword.toLowerCase()
            );
          case 5:
            return dataT.lIVPVendInvoiceStatusString
              .toLowerCase()
              .includes(keyword.toLowerCase());
          case 6:
            return dataT.lecRetHeaderTableField[0].retNumField.includes(
              keyword.toLowerCase()
            );
          case 7:
            return String(dataT.lIVPInvoiceRetTotalField).includes(
              keyword.toLowerCase()
            );
          default:
            setInvoicesTemp(data);
            break;
        }
        return null;
      });
      setInvoicesTemp(results);
    } else {
      setIsfilter(false);
      setInvoicesTemp(data);
    }
  };

  return (
    <>
      <EstadoCuentaFooter
        range={range}
        slice={slice}
        setPage={setPage}
        page={page}
        side={1}
      />
      <Table className="table">
        <Thead className="tableRowHeader">
          <Tr>
            <Th className="tableHeader">{t("invoice")}</Th>
            <Th className="tableHeader">{t("date")}</Th>
            <Th className="tableHeader">{t("amount")}</Th>
            <Th className="tableHeader">{t("balance")}</Th>
            <Th className="tableHeader">{t("datePayment")}</Th>
            <Th className="tableHeader">{t("state")}</Th>
            <Th className="tableHeader">{t("withholding")}</Th>
            <Th className="tableHeader">{t("withholdingValue")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {width > 642 ? (
            <Tr className="tableCell">
              <Td>
                <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(0, e)}
                />
              </Td>
              <Td>
                {/* <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(1, e)}
                /> */}
              </Td>
              <Td>
                {/* <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(2, e)}
                /> */}
              </Td>
              <Td>
                {/* <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(3, e)}
                /> */}
              </Td>
              <Td>
                {/* <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(4, e)}
                /> */}
              </Td>
              <Td>
                <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(5, e)}
                />
              </Td>
              <Td>
                <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(6, e)}
                />
              </Td>
              <Td>
                {/* <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(7, e)}
                /> */}
              </Td>
            </Tr>
          ) : (
            <Tr className="tableCell">
              <Td>
                <input
                  className="form-control"
                  type="text"
                  placeholder={t("filter")}
                  onChange={(e) => filter(0, e)}
                />
              </Td>
            </Tr>
          )}
          {slice.length > 0
            ? slice.map((invoice) => (
                <Tr className="tableRowItems" key={invoice._DocumentHashField}>
                  <Td className="tableCell">{invoice.invoiceField}</Td>
                  <Td className="tableCell">
                    {invoice.transDateField.substring(0, 10)}
                  </Td>
                  <Td className="tableCell">{invoice.amountMSTField}</Td>
                  {invoice.lIVPInvoiceRemainAmountField == null ? (
                    <Td className="tableCell">0.00</Td>
                  ) : (
                    <Td className="tableCell">
                      {invoice.lIVPInvoiceRemainAmountField}
                    </Td>
                  )}
                  <Td className="tableCell">
                    {/* {invoice.lIVPInvoicePaymDateField &&
                      invoice.lIVPInvoicePaymDateField.substring(0, 10)} */}
                    {invoice.lIVPInvoiceRealPaymDateField &&
                      invoice.lIVPInvoiceRealPaymDateField.substring(0, 10)}
                  </Td>
                  <Td className="tableCell">
                    {invoice.lIVPVendInvoiceStatusString}
                  </Td>
                  <Td className="tableCell">
                    {invoice.lecRetHeaderTableField[0].retNumField}
                  </Td>
                  <Td className="tableCell">
                    {invoice.lIVPInvoiceRetTotalField}
                  </Td>
                </Tr>
              ))
            : !isfilter && (
                <Tr>
                  <Td className="cargandoCss" colSpan="8">
                    {t("noInformation")}
                  </Td>
                </Tr>
              )}
        </Tbody>
      </Table>
      <EstadoCuentaFooter
        range={range}
        slice={slice}
        setPage={setPage}
        page={page}
        side={2}
      />
    </>
  );
};

export default TableEstadocuenta;
